import axios from "axios";
import config from "./config";
export default {
    async getLoginConfig() {
        try {
            let { data: c } = await axios.get(config.openkit_url == undefined
                ? ""
                : config.openkit_url + "accounts/config/login/" + config.subdomain);
            return c;
        }
        catch (error) {
            return null;
        }
    },
    async getConfig(id) {
        try {
            let { data: c } = await axios.get(config.openkit_url == undefined
                ? ""
                : config.openkit_url + "accounts/config/" + id, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return c;
        }
        catch (error) {
            return null;
        }
    },
    async getApp(id) {
        try {
            let { data: c } = await axios.get(config.openkit_url == undefined
                ? ""
                : config.openkit_url + "accounts/apps/" + id, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return c;
        }
        catch (error) {
            return null;
        }
    },
    async getLogo() {
        try {
            let reply = await axios.get(config.openkit_url == undefined
                ? ""
                : config.openkit_url + "accounts/logo/" + config.subdomain, {
                responseType: "arraybuffer",
            });
            if (reply.headers["ok-filename"] == "" ||
                reply.headers["ok-filename"] == null) {
                return null;
            }
            return [reply.data, reply.headers["ok-filename"]];
        }
        catch (error) {
            return null;
        }
    },
    async getFavicon() {
        try {
            let reply = await axios.get(config.openkit_url == undefined
                ? ""
                : config.openkit_url + "accounts/favicon/" + config.subdomain, {
                responseType: "arraybuffer",
            });
            return [reply.data, reply.headers["ok-filename"]];
        }
        catch (error) {
            return null;
        }
    },
    async getLogoObjectURL() {
        try {
            const logo = await this.getLogo();
            if (logo == null) {
                return null;
            }
            const newBlob = new Blob([logo[0]], {
                type: "image/" + logo[1].split(".").pop(),
            });
            const url = URL.createObjectURL(newBlob);
            return url;
        }
        catch (error) {
            return null;
        }
    },
    async getFaviconObjectURL() {
        try {
            const logo = await this.getFavicon();
            const newBlob = new Blob([logo[0]], {
                type: "image/" + logo[1].split(".").pop(),
            });
            const url = URL.createObjectURL(newBlob);
            return url;
        }
        catch (error) {
            return null;
        }
    },
    async updateConfig(id, data) {
        try {
            let { data: c } = await axios.put(config.openkit_url == undefined
                ? ""
                : config.openkit_url + "accounts/config/" + id, data, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return c;
        }
        catch (error) {
            return null;
        }
    },
    async patchConfig(id, data) {
        try {
            let { data: c } = await axios.patch(config.openkit_url == undefined
                ? ""
                : config.openkit_url + "accounts/config/" + id, data, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return c;
        }
        catch (error) {
            return null;
        }
    },
};
